/* istanbul ignore file */
import { TextField, FieldProps, useFieldHelper } from 'framework/ui/field';
import InvoiceLink from 'domain/finance/invoice/shared/field/InvoiceLink';
import ExpenseLink from 'domain/finance/expenses/shared/field/ExpenseLink';
import AssetLink from 'domain/finance/assets/shared/field/AssetLink';
import { BUSINESS_OBJECT_TYPES } from 'domain/finance/ledger/useLedgerService';

const JournalEntryBussinessObjectField = ({ source, typeSource }: FieldProps & { typeSource: string }) => {
  const { getValue } = useFieldHelper({ source });
  const { getValue: getType } = useFieldHelper({ source: typeSource });
  const type = getType();
  let value: any = getValue();
  const label = type
    ? type
        .replace(/_/g, ' ')
        .toLowerCase()
        .replace(/^./, char => char.toUpperCase())
    : '';

  switch (type) {
    case BUSINESS_OBJECT_TYPES.INVOICE:
      value = <InvoiceLink source={source} nameSource={source as string} />;
      break;

    case BUSINESS_OBJECT_TYPES.EMPLOYEE_EXPENSE:
      value = <ExpenseLink source={source} nameSource={source as string} isClickable />;
      break;

    case BUSINESS_OBJECT_TYPES.ASSET:
      value = <AssetLink source={source} nameSource={source as string} isClickable />;
      break;

    default:
      value = getValue();
  }

  if (!value) {
    return null;
  }

  return <TextField source={source} value={value} label={label} />;
};

export default JournalEntryBussinessObjectField;
